var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59115 9.25H4.00781V8.41667H4.92448V8H2.17448C1.66822 8 1.25781 7.6269 1.25781 7.16667V2.58333C1.25781 2.1231 1.66822 1.75 2.17448 1.75H10.4245C10.9307 1.75 11.3411 2.1231 11.3411 2.58333V7.16667C11.3411 7.6269 10.9307 8 10.4245 8H7.67448V8.41667H8.59115V9.25ZM2.17448 2.58333V7.16667H10.4245V2.58333H2.17448Z",
    fill: "#103680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorGreen);
export default __webpack_public_path__ + "static/media/monitor_green.86d0efd57909586da1107c761fe8b54c.svg";
export { ForwardRef as ReactComponent };